// middleware
export const SYNC_STATE_TO_STORAGE = '@@redux/SYNC_STATE_TO_STORAGE-' + Math.random().toString(36).substring(7).split('').join('.');
export const GET_STATE_FROM_STORAGE = '@@redux/GET_STATE_FROM_STORAGE-' + Math.random().toString(36).substring(7).split('').join('.');
export const POST_LOGIN = '@@redux/GET_STATE_FROM_STORAGE-' + Math.random().toString(36).substring(7).split('').join('.');
